// @ts-nocheck



import React from 'react';


import AutocompleteSelect from './AutocompleteSelect';
import { washingVehicleTypeApi } from '../../lib/api';




export default (selectProps) =>
<AutocompleteSelect
  placeholder="Выберите тип ТС для моек"
  fetch={async (params) => await washingVehicleTypeApi.fetchList({ ...params })}
  fetchSingle={washingVehicleTypeApi.fetchOne}
  notFoundText="Типы ТС не найдены"
  renderOption={(type, Option) =>
  <Option key={type.id} washingVehicleType={type} value={type.id}>
        {type.type}
      </Option>
  }
  {...selectProps} />;
